import * as z from "zod/v4";

export const deleteRecordingFromCallRecord = {
  name: "deleteRecordingFromCallRecord" as const,
  input: z.object({ callRecordId: z.string(), conversationId: z.string() }),
  output: z.object({ status: z.number() }),
};
